
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getList } from '@/api/common/common'

@Component({
  name: 'tree'
})
export default class Tree extends Vue {
  @Prop({ type: String })
  private url!: string

  private data = []

  @Prop({ type: Object, default: () => ({ children: 'children', label: 'lable' }) })
  private props!: object

  private handleNodeClick (obj: any, node: any, el: any) {
    this.$listeners['node-click'] && this.$emit('node-click', obj, node, el)
  }

  @Watch('searchVal')
  private searchValChange (val: any) {
    (this.$refs.tree as any).filter(val)
  }

  private filterNode (value: any, data: any) {
    if (!value) return true
    return data.lable.indexOf(value) !== -1
  }

  private searchVal = ''

  private loading = !1

  private search () {
    getList({
      url: this.url,
      data: {
        lable: this.searchVal
      }
    }).then((res: any) => {
      if (res.object) {
        this.data = res.object.list
        this.loading = !1
      }
    }).catch(err => {
      console.log('err', err)
      this.loading = !1
    })
  }

  mounted () {
    this.loading = !0
    getList({
      url: this.url,
      data: {
        label: this.searchVal
      }
    }).then((res: any) => {
      if (res.object) {
        this.data = res.object.list
        this.loading = !1
      }
    }).catch(err => {
      console.log('err', err)
      this.loading = !1
    })
  }
}
